import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { LEASING_ACCESS_PERMISSION, LEASING_TERRITORY_SETTINGS_PATH } from '&/features/leasing/paths';
import { requireModule } from '&/lib/module-gate';

export const Route = createFileRoute('/_authenticated/settings_/territories/$territoryId/leasing')({
  beforeLoad: ({ context, params }): void => {
    // Entitlement: a tenant without Leasing gets the standard not-found (the page re-checks on a hard
    // refresh). Permission: without `leasing:access`, back to the territory's General tab, as sibling tabs do.
    requireModule(context.entitlement, LEASING_TERRITORY_SETTINGS_PATH);
    if (context.permissions.isReady && !context.permissions.hasPermission(LEASING_ACCESS_PERMISSION)) {
      throw redirect({ params: { territoryId: params.territoryId }, to: '/settings/territories/$territoryId' });
    }
  },
  component: lazyRouteComponent(
    () => import('&/features/leasing/pages/territory-leasing-settings-page'),
    'TerritoryLeasingSettingsPage',
  ),
  staticData: { titleKey: 'leasingSettings' },
});
